// @material-ui/core
import { Grid, IconButton, Typography } from "@material-ui/core";
// @material-ui/icons
import {
  ViewList as ViewListIcon,
  ViewModule as ViewModuleIcon
} from "@material-ui/icons";
import React, { Component } from "react";
import update from "react-addons-update";
import LicenseCard from "../../library/card/LicenseCard";
import List from "../../library/list";
import Caba from "../../services/Caba";
class Licenses extends Component {
  constructor(props) {
    super(props);
    this.state = {
      licenses: [],
      headers: ["Customer", "App", "Users", "Start", "End", "Trial"],
      data: [],
      isListView: false
    };

    props.toggleLoading(true);
    // make a call
    Caba.get("/api/v1/licenses").then(response => {
      this.props.toggleLoading(false);
      response.data.map((license, index) =>
        Caba.get(`/api/v1/customers/${license.customer}`).then(response => {
          license.customerName = response.data.name;
          const arr = [
            { value: license.appName },
            { value: license.customerName },
            { value: license.numLicenses, numeric: true },
            { value: license.start, date: true },
            { value: license.end, date: true },
            { value: license.trial },
            { value: license.autoprovisioning }
          ];

          this.setState(prevState => {
            let data = update(prevState.data, { $push: [arr] });
            let licenses = update(prevState.licenses, { $push: [license] });
            data = data.sort(
              (a, b) =>
                b[1].value > a[1].value && b[0].value > a[0].value ? -1 : 1
            );
            licenses = licenses.sort(
              (a, b) => (b.customer > a.customer ? -1 : 1)
            );
            return { data, licenses };
          });
        })
      );
    });
  }

  toggleListView = state => {
    this.setState({
      isListView: state
    });
  };

  render() {
    const { data, isListView } = this.state;
    const listItems = this.state.licenses.map((license, index) => {
      return (
        <Grid item xs={12} key={index}>
          <LicenseCard
            object={license}
            key={license.id}
            isExpandable
            slug="licenses"
            id={license.id}
            title={`${license.customerName}: ${license.appName}`}
          />
        </Grid>
      );
    });

    return (
      <Grid container>
        <Grid item xs={6} md={10}>
          <Typography variant="title">{"Licenses"}</Typography>
        </Grid>

        <Grid item xs={6} md={2}>
          <IconButton
            onClick={() => {
              this.toggleListView(true);
            }}>
            <ViewListIcon />
          </IconButton>
          <IconButton
            onClick={() => {
              this.toggleListView(false);
            }}>
            <ViewModuleIcon />
          </IconButton>
        </Grid>

        {!isListView && (
          <Grid item xs={12}>
            <Grid container spacing={16}>
              {listItems}
            </Grid>
          </Grid>
        )}

        {isListView && (
          <Grid item xs={12}>
            <Grid container spacing={16}>
              <List headers={this.state.headers} data={data} />
            </Grid>
          </Grid>
        )}
      </Grid>
    );
  }
}

export default Licenses;



// WEBPACK FOOTER //
// ./src/pages/licenses/Licenses.js